import { Link } from "react-router-dom";

export function AuthShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="auth-shell">
      <section className="auth-hero">
        <div>
          <Link to="/" className="brand">
            Ne<span>ron</span>
          </Link>
          <p className="lede">
            Click-to-call console for your Neron PBX. Sign in with your registered
            mobile number and OTP. Desk phones auto-answer, then the customer rings.
          </p>
        </div>
        <div className="hero-stats">
          <div>
            <b>Broker MQTT</b>
            Cloud CRM ↔ Neron
          </div>
          <div>
            <b>Click to call</b>
            Ext auto-answer
          </div>
          <div>
            <b>Live line</b>
            Idle / in use status
          </div>
        </div>
      </section>
      <section className="auth-card">{children}</section>
    </div>
  );
}
